import ParticipantSearchPanel from "./participantSearch.container";

export default ParticipantSearchPanel;
